import LayoutPrimary from '../../layouts/Primary';
import Settings from '@/views/Admin/Config/Settings/Settings';
import DashboardSettings from '@/views/Admin/Config/Settings/Dashboard';
import EmailSettings from '@/views/Admin/Config/Settings/Email';
import SiteCompletion from '@/views/Admin/Config/Settings/SiteCompletion';
import Whitelabel from '@/views/Admin/Config/Settings/Whitelabel';
import StarterCopy from '@/views/Admin/Config/Settings/StarterCopy';

export default [
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary
        },
        children: [
            {
                path: '/settings/site-completion',
                name: 'SiteCompletion',
                component: SiteCompletion,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary
                }
            },

            {
                path: '/settings/whitelabel',
                name: 'Whitelabel',
                component: Whitelabel,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary
                }
            },

            {
                path: '/settings/starter-copy',
                name: 'StarterCopy',
                component: StarterCopy,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary
                }
            },

            {
                path: '/settings/dashboard',
                name: 'DashboardSettings',
                component: DashboardSettings,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary
                }
            },

            {
                path: '/settings/email',
                name: 'EmailSettings',
                component: EmailSettings,
                meta: {
                    requiresAuth: true,
                    layout: LayoutPrimary
                }
            }
        ]
    }
];
